export default [
  {
    name: "Ingenieria en Informatica y Computacion",
    status: "Incompleta",
    university: "INACAP",
    from: "2010",
    to: "2016",
  },
];
